var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.fieldClass,attrs:{"type":"hidden","id":_vm.fieldId,"name":_vm.fieldName},domProps:{"value":_vm.value},on:{"input":_vm.sendEmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }